import { Injectable, inject } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";

@Injectable({ providedIn: "root" })
export class AlertService {
  private readonly snackBar = inject(MatSnackBar);

  private readonly COMMON_CONFIG: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: "center",
    verticalPosition: "bottom",
  };

  private getDuration(message: string): number {
    if (typeof message !== "string") return 3000;
    const duration = Math.floor((message.length / 5) * 500);
    return duration < 3000 ? 3000 : duration;
  }

  public success(message: string): void {
    this.snackBar.open(message, "✓", {
      ...this.COMMON_CONFIG,
      duration: this.getDuration(message),
      panelClass: ["success-snackbar"],
    });
  }

  public error(message: string): void {
    this.snackBar.open(message, "✖", {
      ...this.COMMON_CONFIG,
      duration: this.getDuration(message),
      panelClass: ["error-snackbar"],
    });
  }

  public warning(message: string): void {
    this.snackBar.open(message, "⚠", {
      ...this.COMMON_CONFIG,
      duration: this.getDuration(message),
      panelClass: ["warning-snackbar"],
    });
  }

  public info(message: string): void {
    this.snackBar.open(message, "ℹ️", {
      ...this.COMMON_CONFIG,
      duration: this.getDuration(message),
      panelClass: ["info-snackbar"],
    });
  }
}
